<template>
  <div class="page-content">
    <breadcrumb-index :items="breadcrumbs">
      <template #actions>
        <router-link to="/app/exams/list" class="btn btn-outline-secondary btn-sm">
          <vue-feather type="arrow-left" size="14" class="me-1" />
          Back
        </router-link>
      </template>
    </breadcrumb-index>

    <div class="card">
      <div class="card-header">
        <h6 class="card-title mb-0">Create New Exam</h6>
      </div>
      <div class="card-body">
        <form @submit.prevent="handleSubmit">
          <div class="row">
            <div class="col-lg-8">
              <div class="row">
                <div class="col-md-6 mb-3">
                  <label class="form-label">Exam Name <span class="text-danger">*</span></label>
                  <input v-model="form.name" type="text" class="form-control" required placeholder="e.g., UPSC Civil Services" />
                </div>
                <div class="col-md-6 mb-3">
                  <label class="form-label">Category <span class="text-danger">*</span></label>
                  <input v-model="form.category" type="text" class="form-control" required placeholder="e.g., Government, Banking, Engineering" />
                </div>
              </div>

              <div class="mb-3">
                <label class="form-label">Description</label>
                <textarea v-model="form.description" class="form-control" rows="3" placeholder="Describe this exam..."></textarea>
              </div>

              <div class="row">
                <div class="col-md-6 mb-3">
                  <label class="form-label">Thumbnail URL</label>
                  <input v-model="form.thumbnail" type="url" class="form-control" placeholder="https://..." />
                </div>
                <div class="col-md-6 mb-3">
                  <label class="form-label">Status</label>
                  <select v-model="form.status" class="form-select">
                    <option value="draft">Draft</option>
                    <option value="active">Active</option>
                  </select>
                </div>
              </div>

              <div v-if="error" class="alert alert-danger">{{ error }}</div>

              <div class="d-flex gap-2 pt-2">
                <button type="submit" class="btn btn-primary" :disabled="loading">
                  <span v-if="loading" class="spinner-border spinner-border-sm me-1"></span>
                  Create Exam
                </button>
                <router-link to="/app/exams/list" class="btn btn-outline-secondary">Cancel</router-link>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import api from '@/services/api'
import { useNotifications } from '@/composables/useNotifications'

export default {
  name: 'AddExam',
  setup() {
    const router = useRouter()
    const { toast } = useNotifications()
    
    const breadcrumbs = [
      { title: 'Dashboard', url: '/app/dashboard' },
      { title: 'Exams', url: '/app/exams/list' },
      { title: 'Create Exam', active: true }
    ]

    const form = ref({
      name: '',
      category: '',
      description: '',
      thumbnail: '',
      status: 'draft'
    })
    const loading = ref(false)
    const error = ref('')

    const handleSubmit = async () => {
      loading.value = true
      error.value = ''

      try {
        const response = await api.post('/v1/admin/exams', { exam: form.value })
        toast.success('Exam created successfully')
        router.push(`/app/exams/edit/${response.data.exam.id}`)
      } catch (err) {
        error.value = err.response?.data?.message || 'Failed to create exam'
        toast.error(error.value)
      } finally {
        loading.value = false
      }
    }

    return { breadcrumbs, form, loading, error, handleSubmit }
  }
}
</script>
